export default "__VITE_ASSET__DKCYe2ha__"